export default __webpack_public_path__ + "static/media/Strugani 24.9943eba6.jpg";